<template>
  <div class="about">
    <h1>This is an about page</h1>
    <twitch-player :channel="channel" :includeChat="true" />
    <mixer-player :channel="channel" :includeChat="true" />
  </div>
</template>

<script>
import { Twitch, Mixer } from '@/components';
export default {
  components: {
    'twitch-player': Twitch,
    'mixer-player': Mixer
  },
  data() {
    return {
      channel: 'monstercat'
    };
  }
};
</script>
